export class KeyValue<T> {
    key: string;
    value: T;
    require?: string;

    constructor(key: string, value: T, require?:string) {
        this.key = key;
        this.value = value;
        this.require = require;
    }
}
